<mat-card class="mb-3 mb-md-2 col-md-12 d-flex flex-column h-100 custom-card">
  <mat-card-header>
    <mat-card-title>Distribuzione fatturato per cliente</mat-card-title>
    <mat-card-subtitle>
      Migliori clienti per fatturato
      <span *ngIf="totalInvoices > 0"
        >({{ totalInvoices }} fatture totali nel {{selectedYear}})</span
      >
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="mt-2">
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>

    <div
      *ngIf="!isLoading && !errorMessage"
      style="height: 400px; position: relative"
    >
      <canvas
        baseChart
        [data]="pieChartData"
        [options]="pieChartOptions"
        [type]="pieChartType"
        style="cursor: pointer;">
      >
      </canvas>
    </div>
  </mat-card-content>

  <mat-card-actions class="d-flex justify-content-end">
    <button mat-raised-button color="primary" (click)="refreshData()">
      Ricarica dati
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>
